export default __webpack_public_path__ + "static/media/07__o_3.67cfacb7.jpg";